import groupsActions from './actions';

const initialState = {
    remodelumGroups: {},
    groupsError: '',
    searchGroupText: '',
    groupsSuccess: '',
    isLoadingGroups: false,
};

export default function groupsReducer(state = initialState, action) {
    switch (action.type) {
        case groupsActions.LOAD_MY_GROUPS_START:
            return { ...state, ...action.payload, isLoadingGroups: true };
        case groupsActions.LOAD_MY_GROUPS_SUCCESS:
            return { ...state, ...action.payload, isLoadingGroups: false };
        case groupsActions.LOAD_MY_GROUPS_FAILED:
            return { ...state, ...action.payload, isLoadingGroups: false };
        case groupsActions.CREATE_GROUP_START:
            return {
                ...state,
                ...action.payload,
                isLoadingGroups: true,
            };
        case groupsActions.CREATE_GROUP_SUCCESS:
            return { ...state, ...action.payload, isLoadingGroups: false };
        case groupsActions.CREATE_GROUP_FAILED:
            return { ...state, ...action.payload, isLoadingGroups: false };
        case groupsActions.EDIT_GROUP_START:
            return { ...state, ...action.payload, isLoadingReferrals: true };
        case groupsActions.EDIT_GROUP_SUCCESS:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case groupsActions.EDIT_GROUP_FAILED:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case groupsActions.DELETE_GROUP_START:
            return { ...state, ...action.payload };
        case groupsActions.DELETE_GROUP_SUCCESS:
            return { ...state, ...action.payload };
        case groupsActions.DELETE_GROUP_FAILED:
            return { ...state, ...action.payload };
        case groupsActions.ABANDON_GROUP_START:
            return { ...state, ...action.payload };
        case groupsActions.ABANDON_GROUP_SUCCESS:
            return { ...state, ...action.payload };
        case groupsActions.ABANDON_GROUP_FAILED:
            return { ...state, ...action.payload };
        case groupsActions.UNASSIGN_MEMBER_START:
            return { ...state, ...action.payload };
        case groupsActions.UNASSIGN_MEMBER_SUCCESS:
            return { ...state, ...action.payload };
        case groupsActions.UNASSIGN_MEMBER_FAILED:
            return { ...state, ...action.payload };
        case groupsActions.INVITE_MEMBER_START:
            return { ...state, ...action.payload };
        case groupsActions.INVITE_MEMBER_SUCCESS:
            return { ...state, ...action.payload };
        case groupsActions.INVITE_MEMBER_FAILED:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}